// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__CN9dr","label":"Breadcrumb_label__qQGNA"};